<template>
    <div class="end">
        <div class="end-preface">
        <div class="end-preface-content">
            <p>看更多<span class="number">9</span><span class="number">2</span><span class="number">1</span>重建故事</p>
        </div>
        </div>
        <div class="end-nav">
        <div class="container">
            <div  v-show="isStart === false" class="change-page change-page-prev">
            <div class="page-description">
                {{ lastName }}
            </div>
            <div @click="handleGoLastPageGA($event, lastUrl)" class="page-btn prev-page-btn"></div>
            </div>
            <div class="page-number">
            {{ pageNumber }}
            </div>
            <div v-show="isEnd === false"  class="change-page change-page-next">
            <div class="page-description">
                {{ nextName }}
            </div>
            <div @click="handleGoNextPageGA($event, nextUrl)" class="page-btn next-page-btn"></div>
            </div>
        </div>
        </div>
    </div> 
</template>
<script>
import Utils from 'udn-newmedia-utils'
import srcRWD from '@/mixin/srcRWD.js'


export default {
  name: 'end',
  data () {
    return {

    }
  },
  mounted () {

  },
  props: {
    lastUrl: {
      type: String,
      default: 'https://udn.com/newmedia/921/people/ke/'
    },
    lastName: {
      type: String,
      default: '上一頁'
    },
    nextUrl: {
      type: String,
      default: 'https://udn.com/newmedia/921/people/hsieh/'
    },
    nextName: {
      type: String,
      default: '如果再包容一點'
    },
    pageNumber: {
      type: String,
      default: '3/6'
    },
    isEnd: {
      type:Boolean,
      default: false
    },
    isStart: {
      type:Boolean,
      default: false
    }
  },
  mixins: [srcRWD],
  components: {

  },
  methods: {
    handleGoLastPageGA (event, lastUrl) {
      let location = window.location.pathname;
      let path = location.substring(0, location.lastIndexOf("/"));
      let directoryName = path.substring(path.lastIndexOf("/")+1);
      
      window.ga('newmedia.send', 'event', {
        eventCategory: 'Button_' + directoryName,
        eventAction: 'Click_' + directoryName,
        eventLabel: "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "][ 上一篇 ]"
      });

      setTimeout(function() {
        document.location.href = lastUrl;
      }, 100);
    },
    handleGoNextPageGA (event, nextUrl) {
      let location = window.location.pathname;
      let path = location.substring(0, location.lastIndexOf("/"));
      let directoryName = path.substring(path.lastIndexOf("/")+1);

      window.ga('newmedia.send', 'event', {
        eventCategory: 'Button_' + directoryName,
        eventAction: 'Click_' + directoryName,
        eventLabel: "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "][" + this.nextName + "]"
      });

      setTimeout(function() {
        document.location.href = nextUrl;
      }, 100);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../sass/_variables.scss";

.end {
  margin-top: 120px;
    .end-preface {
      display: flex;
      justify-content: center;
      .end-preface-content {
        -webkit-writing-mode: vertical-rl;
        writing-mode: vertical-rl;
        -webkit-text-orientation: upright;
        text-orientation: upright;
        letter-spacing: .7rem;
        .number {
          margin: 0;
          @media (min-width: 768px) and (max-width: 1279.98px) {

          }
          @media (min-width: 1280px) {
            padding: 5px 0px 5px 1.5px;
            &:nth-child(3) {
              padding-bottom: 11px;
            }
            writing-mode: lr-tb;
            line-height: 26px;
            letter-spacing: 0px;              
          }
        }
      } 
    }
    .end-nav {
      width: 100%;
      height: 50vh;
      background-image: url('../share_source/background_mob2.png');
      background-repeat: no-repeat;
      background-size: cover;
      color: $light-gray;
      position: relative;
      z-index: 5040;
      @media (min-width: 768px) and (max-width: 1279.98px) {

      }
      @media (min-width: 1280px) {
         background-image: url('../share_source/background_pc2.png');
      }
      .change-page {
        @media (min-width: 768px) and (max-width: 1279.98px) {
          display: flex;
          align-items: center;
        }
        @media (min-width: 1280px) {
          display: flex;
          align-items: center;
        }
        .page-description {
          @media (min-width: 768px) and (max-width: 1279.98px) {
            padding: 0 20px;
          }
          @media (min-width: 1280px) {
            padding: 0 20px;
          }
        }
        .page-btn {
          width: 70px;
          height: 56px;
          border-radius: 6px;
          margin: 5px 0px;
          &:hover {
            transition: all .3s;
            background-color: $light-gray;
            opacity: 0.7;
            &::before, &::after {
              border: solid 1px black;
            }
          }
        }
      }
      .change-page-prev {
        position: absolute;
        left: 4%;
        bottom: 67px;
        flex-direction: row-reverse;
        @media (min-width: 768px) and (max-width: 1279.98px) {
            left: 11%;
        }
        @media (min-width: 1280px) {
            left: 11%;
        }
        .prev-page-btn {
          float: left;
          position: relative;
          border: solid 0.5px $light-gray;
          cursor: pointer;
          &::after {
            content: '';
            display: block;
            border: solid 1px $light-gray;
            width: 15%;
            position: absolute;
            left: 50%;
            top: 51%;
            transform-origin: left;
            transform: translate(-50%, -50%) rotate(-45deg);
          }
           &::before {
            content: '';
            display: block;
            border: solid 1px $light-gray;
            width: 15%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform-origin: left;
            transform: translate(-50%, -50%) rotate(45deg);
          }
        }
      }
      .page-number {
        position: absolute;
        bottom: 67px;
        left: 50%;
        transform: translate(-50%);
        line-height: 60px;
        opacity: 0.5;
      }
      .change-page-next {
        position: absolute;
        right: 4%;
        bottom: 67px;
         @media (min-width: 768px) and (max-width: 1279.98px) {
            right: 11%;
        }
        @media (min-width: 1280px) {
            right: 11%;
        }
        .next-page-btn {
          float: right;
          position: relative;

          border: solid 0.5px $light-gray;
          cursor: pointer;
          &::after {
            content: '';
            display: block;
            border: solid 1px $light-gray;
            width: 15%;
            position: absolute;
            left: 50%;
            top: 48%;
            transform-origin: right;
            transform: translate(-50%, -50%) rotate(-45deg);
          }
           &::before {
            content: '';
            display: block;
            border: solid 1px $light-gray;
            width: 15%;
            position: absolute;
            left: 50%;
            top: 50.5%;
            transform-origin: right;
            transform: translate(-50%, -50%) rotate(45deg);
          }
        }
      }
    }
  }
</style>
